import { render, staticRenderFns } from "./pt-table.vue?vue&type=template&id=2946a86a&scoped=true&"
import script from "./pt-table.vue?vue&type=script&lang=js&"
export * from "./pt-table.vue?vue&type=script&lang=js&"
import style0 from "./pt-table.vue?vue&type=style&index=0&id=2946a86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946a86a",
  null
  
)

export default component.exports